import { Component } from "@angular/core";

@Component({
  selector: 'app-produtor-rural',
  templateUrl: './produtor-rural.component.html',
  styleUrls: ['./produtor-rural.component.scss']
})
export class ProdutorRuralComponent {

}